import { useContext, useEffect, useState } from 'react';
import { getExpedientDetails } from '../services/getExpedientDetails';
import LoaderContext from '../../../../layout/shared/loader_context';
import { NotificationManager } from 'react-notifications';
import { downloadExpedientZip } from '../../../../../services/downloadExpedientZip';

const useExpedientConsultationState = (props) => {
  const [expedientDetails, setExpedientDetails] = useState({});
  const {
    match: {
      params: { accessToken },
    },
  } = props;
  const loader = useContext(LoaderContext);

  // SEG-071: la firma HMAC viaja como query (?expires=&signature=) en el QR;
  // la reenviamos tal cual al cover y a la descarga.
  const signatureQuery = props.location && props.location.search ? props.location.search : '';

  const handleGetExpedientDetails = async () => {
    try {
      loader.show(true);
      const expedientDetailsResponse = await getExpedientDetails(accessToken, signatureQuery);
      setExpedientDetails(expedientDetailsResponse);
    } catch (error) {
      NotificationManager.error(error.message);
    } finally {
      loader.show(false);
    }
  };

  useEffect(() => {
    handleGetExpedientDetails();
  }, []);

  const handleDownloadDocuments = async () => {
    const urlDowload = `${process.env.REACT_APP_URL_API_LARAVEL}/qrs/${accessToken}${signatureQuery}`;

    await downloadExpedientZip(urlDowload, { loader });
  };

  return {
    expedientDetails,
    accessToken,
    handleDownloadDocuments,
  };
};

export default useExpedientConsultationState;
